import { useEffect, useState } from "react";
import { ExcludedSeller } from "types";

export const useExcludedSellerForm = (
  excludedSeller: ExcludedSeller | null | undefined,
) => {
  const [username, setUsername] = useState<string>("");
  const [comment, setComment] = useState<string>("");

  const resetExcludedSellerForm = () => {
    setUsername("");
    setComment("");
  };

  useEffect(() => {
    if (excludedSeller === null || excludedSeller === undefined) {
      return;
    }

    setUsername(excludedSeller.username);
    setComment(excludedSeller.comment ?? "");
  }, [excludedSeller]);

  return {
    username,
    setUsername,
    comment,
    setComment,
    resetExcludedSellerForm,
  };
};
